"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* Config for style overrides */
var styleConfig = {
  secondary: {
    background: "var(--color-global-black)",
    hover: {
      background: "var(--color-brand-mid)"
    },
    focus: {},
    active: {
      background: "var(--color-brand-dark)"
    }
  },
  tertiary: {
    border: "1px solid var(--color-global-black)",
    background: "var(--color-global-white)",
    color: "var(--color-global-black)",
    hover: {
      border: "1px solid var(--color-brand-mid)",
      background: "var(--color-global-white)"
    },
    focus: {
      border: "1px solid var(--color-global-white)"
    },
    active: {
      color: "var(--color-brand-mid)",
      background: "var(--color-global-white)"
    },
    disabled: {
      border: "1px solid var(--color-global-grey400)",
      color: "var(--color-global-grey400)",
      background: "var(--color-global-white)"
    }
  },
  large: {
    borderRadius: '6px',
    padding: "var(--spacing-global-space4) var(--spacing-global-space7)",
    boxShadow: "var(--elevation-shadow-s)",
    lineHeight: "var(--font-line-height-1)",
    fontSize: "var(--font-size-1)",
    sidePadding: '20px',
    iconSize: "".concat(Math.round(24 / 16 * 1.6 * 10) / 10, "rem") // Multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original icon size is 24px
  },
  medium: {
    borderRadius: '4px',
    padding: "10px var(--spacing-global-space6)",
    boxShadow: "var(--elevation-shadow-xs)",
    lineHeight: "var(--font-line-height-m1)",
    fontSize: "var(--font-size-m1)",
    sidePadding: '14px',
    iconSize: "".concat(Math.round(20 / 16 * 1.6 * 10) / 10, "rem") // Multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original icon size is 20px
  },
  small: {
    borderRadius: '2px',
    padding: "var(--spacing-global-space3) var(--spacing-global-space5)",
    boxShadow: "var(--elevation-shadow-xxs)",
    lineHeight: "var(--font-line-height-m2)",
    fontSize: "var(--font-size-m2)",
    sidePadding: 'var(--spacing-global-space4)',
    iconSize: "".concat(Math.round(16 / 16 * 1.6 * 10) / 10, "rem") // Multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original icon size is 16px
  }
};
var _default = exports["default"] = styleConfig;